var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 19.4172C13.6514 19.8057 13.1814 20 12.6298 20C12.0783 20 11.6083 19.8057 11.2197 19.4172L4.60165 12.7991C4.41363 12.611 4.26623 12.395 4.15944 12.1508C4.05315 11.9061 4 11.6459 4 11.3702V5.99295C4 5.44144 4.19428 4.97141 4.58284 4.58284C4.97141 4.19428 5.44144 4 5.99295 4H11.3702C11.6459 4 11.9061 4.05315 12.1508 4.15944C12.395 4.26623 12.611 4.41363 12.7991 4.60165L19.4172 11.2197C19.8057 11.6083 20 12.0783 20 12.6298C20 13.1814 19.8057 13.6514 19.4172 14.04L14.04 19.4172ZM7.87309 9.00118C8.18645 9.00118 8.45268 8.89138 8.67177 8.67177C8.89138 8.45268 9.00118 8.18645 9.00118 7.87309C9.00118 7.55973 8.89138 7.29351 8.67177 7.07441C8.45268 6.85481 8.18645 6.74501 7.87309 6.74501C7.55973 6.74501 7.29351 6.85481 7.07441 7.07441C6.85481 7.29351 6.74501 7.55973 6.74501 7.87309C6.74501 8.18645 6.85481 8.45268 7.07441 8.67177C7.29351 8.89138 7.55973 9.00118 7.87309 9.00118Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.19496ad67fdd1a492bed3200cd3c570c.svg";
export { ForwardRef as ReactComponent };